import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    FormGroup,
    Table,
    Button,
    AccordionItem,
    AccordionHeader,
    AccordionBody,
    UncontrolledAccordion,
    Modal,
    ModalHeader,
    ModalBody,
    Container,
    Row,
    Col
} from 'reactstrap';
import '../GerenciamentoTurmas/GerenciamentoTurmas.css';
import SockJsClient from 'react-stomp';
import ListaRegistroPorResponsavel from '../ListaRegistroPorResponsavel/ListaRegistroPorResponsavel';
import ListaRegistroAlunos from '../ListaRegistroAlunos/ListaRegistroAlunos';



const ListaAguardo = ({ token, deParaUnidades }) => {
    const [listaTurmas, setListaTurmas] = useState(JSON.parse(localStorage.getItem('listaTurmas')));
    const [listaTurmasBackup, setListaTurmasBackup] = useState(JSON.parse(localStorage.getItem('listaTurmas')));
    const [selecaoTurmaMenu, setSelecaoTurmaMenu] = useState(true);
    const [unidade, setUnidade] = useState();
    const [listaAguardo, setListaAguardo] = useState();
    const [turmasAccordion, setTurmasAccordion] = useState([]);
    const [openWebSocket, setOpenWebSocket] = useState(false);
    const [turmasAccordionBackup, setTurmasAccordionBackup] = useState(useState(JSON.parse(localStorage.getItem('turmasAguardo'))));
    const [listaSelecaoTurmas, setListaSelecaoTurmas] = useState();
    const [checkedState, setCheckedState] = useState({});
    const [alunoInfo, setAlunoInfo] = useState();
    const [modalRegistro, setModalRegistro] = useState();
    const [msgTimeStamp, setMsgTimeStamp] = useState((new Date()).toISOString());
    const username = process.env.REACT_APP_ANJO_BACKEND_USER
    const password = process.env.REACT_APP_ANJO_BACKEND_PSW

    const statusOrder = {
        "PRONTO": 4,
        "PRONTO_ESPECIAL": 3,
        "AGUARDANDO": 2,
        "RETIRADO": 1,
    };

    const handleModalRegistro = () => {
        setModalRegistro(!modalRegistro);
    }

    const handleOnChange = (turma) => {

        setCheckedState(prevState => ({
            ...prevState,
            [turma.codigoTurma]: !prevState[turma.codigoTurma] || false
        }));
    }

    const marcarSaidaAguardo = async (aluno) => {
        const response = await axios.post("aluno/marcar/saidaAguardo/" + token.usuario.matricula, aluno,
            {
                auth: {
                    username,
                    password
                }
            });
    }



    const handleSelectedAluno = (aluno) => {
        let currentStamp = new Date();
        setMsgTimeStamp(currentStamp.toISOString());
        if (aluno.statusPronto === "PRONTO" || aluno.statusPronto === "PRONTO_ESPECIAL") {
            if (window.confirm("Por favor confirmar saída.")) {
                currentStamp.setSeconds(currentStamp.getSeconds() + 3);
                setMsgTimeStamp(currentStamp.toISOString());

                let orderedList = listaAguardo.slice();
                let alunoEditarIndex = orderedList.findIndex(member => member.cdAluno === aluno.cdAluno);

                if (alunoEditarIndex !== -1) {
                    orderedList[alunoEditarIndex].statusPronto = "RETIRADO";
                }
                orderedList.sort((a, b) => {
                    const statusComparison = statusOrder[b.statusPronto] - statusOrder[a.statusPronto];
                    if (statusComparison !== 0) {
                        return statusComparison;
                    }
                    return compareDates(a , b);
                });
                setListaAguardo(orderedList);
                fillTurmasAccordion();
                marcarSaidaAguardo(aluno);
            }
        }
    }

    const handleSaidaProfessor = async (responsavel) => {
        let responsaveis = [];
        let alunoList = []
        responsaveis.push(responsavel);
        alunoInfo.resposaveis = responsaveis;
        alunoList.push(alunoInfo);
        const entradaResponse =
            await axios.post('aluno/marcar/saidaMultiple/' + "PROFESSOR", alunoList,
                {
                    auth: {
                        username,
                        password
                    }
                });
        handleModalRegistro();
    }

    const prepararListaTurmas = () => {
        let listaPreparada = [];
        listaTurmasBackup.map((turma, index) => {
            if (checkedState[turma.codigoTurma]) {
                listaPreparada.push(listaTurmasBackup[index]);
            }
        })
        setListaSelecaoTurmas(listaPreparada);
        setSelecaoTurmaMenu(false);
    }

    const filterList = (valorReferencia) => {
        setListaTurmas(listaTurmasBackup);
        if (valorReferencia) {
            let listaTurmaMod = listaTurmasBackup.filter(turma => substringComparator(
                turma.nomeTurma.toUpperCase().replaceAll(' ', ''), valorReferencia.trim().toUpperCase()));
            setListaTurmas(listaTurmaMod);
        }
    }

    const substringComparator = (valorBase, valorReferencia) => {
        let splitReferencia = valorReferencia.split(' ');
        let values = 0;
        for (let substring of splitReferencia) {
            if (valorBase.includes(substring)) {
                values++;
            }
        };
        return values === splitReferencia.length;
    }

    const topic = '/topic/telaRetiroPorta/' + unidade;

    const onConnected = () => {
        console.log("Connected!!")
    }

    let onMessageReceived = (msg) => {
        let arrivedMsgTimeStamp = msg[0].updateTimeStamp;
        if (arrivedMsgTimeStamp > msgTimeStamp) {
            let orderedList = msg.slice();
            orderedList.sort((a, b) => {
                const statusComparison = statusOrder[b.statusPronto] - statusOrder[a.statusPronto];
                if (statusComparison !== 0) {
                    return statusComparison;
                }
                return compareDates(a , b);
            });
            setListaAguardo(prevList => orderedList);
            fillTurmasAccordion();
            setMsgTimeStamp((new Date()).toISOString());
        }
    }

    const compareDates = (a, b) => {
        const dateA = new Date(a.lastUpdate).getTime();
        const dateB = new Date(b.lastUpdate).getTime();

        return dateA - dateB;
    };

    const formatDateInHours = (date) => {
        const formattedTime = new Date(date).toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false  // Use 24-hour format, set to true for AM/PM format
          });

        return formattedTime
    }

    useEffect(() => {
        definirUnidade();
    }, []);

    const definirUnidade = () => {
        let cdUnidadeDb2 = token.usuario.departamento.id.codfilial;
        setUnidade(deParaUnidades[cdUnidadeDb2]);
    }

    const fillTurmasAccordion = () => {
        if (listaAguardo != null) {
            let turmasSet = new Set();
            listaAguardo.map(aluno => turmasSet.add(aluno['turmaAluno']));
            localStorage.setItem('turmasAguardo', JSON.stringify(Array.from(turmasSet)));
            setTurmasAccordion(Array.from(turmasSet));
        }
    }

    const renderListaAguardo = () => {
        let renderedList = [];
        let alunosList = [];
        for (let turma of listaSelecaoTurmas) {
            for (let aluno of listaAguardo) {
                if (aluno['turmaAluno'] === turma.nomeTurma) {
                    alunosList.push(aluno);
                }
            }
        }
        alunosList.sort((a, b) => {
            const statusComparison = statusOrder[b.statusPronto] - statusOrder[a.statusPronto];
            if (statusComparison !== 0) {
                return statusComparison;
            }
            return compareDates(a , b);
        });
        renderedList.push(renderAccordionTurma(alunosList));
        return (renderedList);
    }

    const renderAccordionTurma = (alunosList) => {
        return (
            <AccordionItem className="accordionGer">
                <AccordionHeader targetId="Selecao" >
                    <h5>SELEÇÃO</h5>
                </AccordionHeader>
                <AccordionBody accordionId="Selecao" className="accordionBody">
                    {alunosList.map((aluno) =>
                        <div id={aluno.cdAluno} className={aluno.statusPronto === "AGUARDANDO" ? "alunoAguardo" :
                            (aluno.statusPronto === "PRONTO" ? "alunoAguardoPronto" :
                                (aluno.statusPronto === "RETIRADO" ? "alunoRetirado" : "alunoAguardoProntoEspecial"))}
                            onPointerUp={() => handleSelectedAluno(aluno)}>
                            {aluno.nomeAluno + " [" + formatDateInHours(aluno.lastUpdate) + "]"} <div className="ResponsavelInfoAguardo">{aluno.turmaAluno}</div>
                            {aluno.statusPronto !== "AGUARDANDO" &&(
                                <div className="ResponsavelInfoAguardo" rendered="false">
                                    {aluno.nomeResponsavelSaida}
                                    {" (" + aluno.vinculoResponsavelSaida + ")"}
                                </div>
                            )}
                        </div>
                        )}
                </AccordionBody>
            </AccordionItem>
        );
    }

    const selecaoInicialTurmas = () => {
        return (
            <>
                <div className="TabelaConfig">
                    <div className="SelecaoDeTurmas">
                    {listaTurmas.map((turma, index) =>
                        <div className="SelecaoDeTurmasItem" id={index} onClick={() => handleOnChange(turma)}>
                        <h8 className="tabelaComponent">
                            {turma.nomeTurma}
                        </h8>
                        <input
                            className="registroCheckBox"
                            type="checkbox"
                            name={turma.nomeTurma}
                            value={turma.nomeTurma}
                            checked ={checkedState[turma.codigoTurma] || false}
                            size="150"
                            />
                        </div>
                        )}
                        </div>
                <Button className="submitRegistrosButton" type="button" onClick={() => prepararListaTurmas()}>
                    Aceitar
                </Button>
            </div>
          </>
        );
    }

    const renderAccordion = () => { 
        return (
            <>
                <Container>
                    <Row style={{ 'margin': '10px', 'padding-left':'8%' } }>
                        <Col
                            sm="12"
                        >
                            <Button className="submitRegistrosButton" type="button" onClick={() => window.location.reload()}>
                                Voltar
                            </Button>
                        </Col>
                    </Row>
                </Container>
                <UncontrolledAccordion className="accordionConfig" defaultOpen={turmasAccordion} stayOpen>
                    {renderListaAguardo()}
                </UncontrolledAccordion>
            </>
        );
    }


    return (
            <>
                <div>
                    < SockJsClient
                        url={'ws-messages/'}
                        topics={[topic]}
                        onConnect={() => onConnected()}
                        onDisconnect={() => console.log("Disconnected!")}
                        onMessage={(msg) => { setTimeout(onMessageReceived(msg),1000) }}
                        debug={false}
                        onConnectFailure={(error) => { console.log(error) }} />
                </div>
            <h2 className="titulosPaginas">Solicitação de Saída</h2>
            <input type="text" placeholder="Buscar por Nome" className="pesquisaRapidaTurmas"
                onChange={(e) => filterList(e.target.value)} />
                {selecaoTurmaMenu && selecaoInicialTurmas()}
            {!selecaoTurmaMenu && (listaAguardo && renderAccordion())}

            <Modal isOpen={modalRegistro} toggle={handleModalRegistro}>
                <ModalHeader className="TabelaGer" toggle={handleModalRegistro}>
                    <div className="TopRegistro">
                        <h4>Registro de Saida Para:  {alunoInfo ? alunoInfo.nome: ""}</h4>
                    </div>
                </ModalHeader>
                <ModalBody className="modalConfig">
                    <ListaRegistroPorResponsavel
                        aluno={alunoInfo}
                        putAluno={handleSaidaProfessor} />
                </ModalBody>
            </Modal>
            </>
        )
}

export default ListaAguardo;
